import React from "react";
import { Seo } from "./Seo/Seo.tsx";
import { findBySlug } from "./Seo/routeSeo.ts";
import { ConsentSettings } from "./Consent/ConsentSettings.tsx";

/**
 * A page that is prose and nothing else - About, Privacy - as opposed to the
 * landing pages, which wrap a generator.
 *
 * It is the /404 shape (a manifest entry read through findBySlug, an explicit
 * route in App.js rather than manifest dispatch) generalised, because there is
 * now more than one of them. Content lives in routeSeo.json like every other
 * page's, so scripts/prerender.js bakes these into static HTML with the same
 * title, canonical and FAQ handling as everything else and needs no special
 * case.
 */
export function ContentPage({ slug }: { slug: string }) {
    const entry = findBySlug(slug);

    if (!entry) {
        return null;
    }

    return (
        <>
            <Seo entry={entry} />
            <div className="landingContent">
                <h1>{entry.h1}</h1>
                {entry.intro?.map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                ))}
                {/* The policy explains what is collected, then offers the
                    control over it. ConsentSettings renders nothing where
                    consent does not apply. */}
                {entry.consentControl && <ConsentSettings />}
                {entry.faq && entry.faq.length > 0 && (
                    <section className="landingFaq">
                        <h2>Frequently asked questions</h2>
                        {entry.faq.map((item) => (
                            <div className="faqItem" key={item.q}>
                                <h3>{item.q}</h3>
                                <p>{item.a}</p>
                            </div>
                        ))}
                    </section>
                )}
            </div>
        </>
    );
}

export default ContentPage;
